// An explicit WebSocket base may be used when notifications have a separate host.
export function buildNotificationUrl(apiBase, userId, wsBase, origin) {
    const api = new URL(apiBase || '/', origin);
    const base = wsBase ? new URL(wsBase, api) : new URL('/ws/', api);
    base.protocol = base.protocol === 'https:' || base.protocol === 'wss:' ? 'wss:' : 'ws:';
    base.pathname = `${base.pathname.replace(/\/$/, '')}/notifications/user/${encodeURIComponent(userId)}/`;
    base.search = '';
    base.hash = '';
    return base.href;
}
